import { Level } from "../../../../models";

export const processLevelsResponse = (levels: Level[]): Level[] => {
    return levels.map((level: Level) => {
        const newLevel: Level = {
            id: level.id,
            level: level.level,
            startNumber: level.startNumber,
            count: level.count,
            displayName: level.displayName
        }

        return newLevel;
    })
}